import { observer } from 'mobx-react-lite';
import { Layout, Menu } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { MenuProps } from 'antd/lib';
const { Sider, Content } = Layout;

export const RentalPortal = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems: MenuProps['items'] = [
    {
      label: 'Rental Properties',
      key: '/eiq-manage/rental-portal/properties',
    },
    {
      label: 'Rental Reservations',
      key: '/eiq-manage/rental-portal/reservations',
    },
  ];

  const selectedKey = menuItems?.map((item) => String(item?.key)).find((key) => location.pathname.startsWith(key));

  return (
    <Layout hasSider className="accounts-layout">
      <Sider className="sider-wrapper">
        <Menu
          selectedKeys={selectedKey ? [selectedKey] : []}
          items={menuItems}
          className="sider-tabs"
          onClick={(tab) => navigate(tab.key)}
        />
      </Sider>
      <Content className="content-style">
        <Outlet />
      </Content>
    </Layout>
  );
});
